import *  as ActionTypes from "./list-propertyActionTypes";

const initialState = {
    isLoading: false,
    isSaved: false,
};

export const listPropertyReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.CREATE_LIST_PROPERTY:
            return {
                ...state,
                isLoading: true,
                isSaved: false,
            }
        case ActionTypes.CREATE_LIST_PROPERTY_FAILURE:
            return {
                ...state,
                isLoading: false,
            }
        case ActionTypes.CREATE_LIST_PROPERTY_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSaved: true,
            }
        default:
            return state

    }
}